import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";

import CircularProgress from "@material-ui/core/CircularProgress";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";

import connection from "../connection";

import Clear from "@material-ui/icons/Clear";
import CheckIcon from "@material-ui/icons/Check";

import userSearchStyle from "assets/jss/material-dashboard-pro-react/views/userSearchStyle.jsx";

class UserSearch extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      user: props.defaultUser || null,
      loading: false
    };

    this.inputTimeout = null;
    this.inputPasting = false;

    this.changeInput = this.changeInput.bind(this);
  }

  changeInput(e) {
    const {onFoundUser, inputProps, onUserNotFound, skipStatusCheck} = this.props;
    let searchDelay = this.props.searchDelay;
    let query = e.target.value;
    clearTimeout(this.inputTimeout);
    if (e.clipboardData) {
      if (inputProps.type === "number") {
        query = parseInt(e.clipboardData.getData("text/plain"), 10);
      } else {
        query = e.clipboardData.getData("text/plain");
      }
      searchDelay = 1;
      this.inputPasting = true;
    }
    if (query == null || query === "" || (inputProps.type === "number" && isNaN(query))) {
      this.setState({
        user: null,
        loading: false
      });
    } else {
      this.setState({
        loading: true
      });
      this.inputTimeout = setTimeout(() => {
        this.inputPasting = false;
        this.inputTimeout = null;
        connection.get("utilizador/pesquisar", {q: query, skip_status_check: skipStatusCheck}, (data) => {
          onFoundUser(data.user);
          this.setState({
            user: data.user,
            loading: false
          });
        }, (err) => {
          onUserNotFound && onUserNotFound(query);
          this.setState({
            user: {},
            loading: false
          });
        });
      }, searchDelay || 300);
    }
  }

  render() {
    const {
      classes,
      formControlProps,
      labelText,
      id,
      labelProps,
      inputProps,
      inputRootCustomClasses,
      defaultUser,
      value
    } = this.props;

    let formControlClasses;
    if (formControlProps !== undefined) {
      formControlClasses = classNames(
        formControlProps.className,
        classes.formControl
      );
    } else {
      formControlClasses = classes.formControl;
    }

    const marginTop = classNames({
      [inputRootCustomClasses]: inputRootCustomClasses !== undefined
    });

    const inputClasses = classNames({
      [classes.input]: true
    });

    let foundUserLabel;
    if (this.state.user) {
      if (this.state.user.id) {
        foundUserLabel = (<React.Fragment>
          {!this.state.loading ? (<CheckIcon className={classes.foundUserIcon}/>) : null}
          <h4 className={classes.foundUserName}>{this.state.user.nome}</h4>
          <p className={classes.foundUserLocation}>{this.state.user.agrupamento} / {this.state.user.regiao}</p>
          {this.state.user.tipos && <p className={classes.foundUserTypes}>{this.state.user.tipos.filter((tipo) => tipo.id > 0).map(tipo => tipo.designacao).join(", ")}</p>}
        </React.Fragment>);
      } else {
        foundUserLabel = (<React.Fragment>
          {!this.state.loading ? (<Clear className={classes.notFoundUserIcon}/>) : null}
          <span className={classes.notFoundUserLabel}>Utilizador não encontrado</span>
        </React.Fragment>);
      }
    }
    let foundUserBox = (
      <div className={classes.foundUserBox}>
        {this.state.loading ? (<CircularProgress className={classes.foundUserLoading} size={30} thickness={3}/>) : null}
        {foundUserLabel}
      </div>);

    return (<FormControl {...formControlProps} className={formControlClasses}>
      {labelText !== undefined ? (
        <InputLabel
          className={classes.labelRoot}
          htmlFor={id}
          {...labelProps}
        >
          {labelText}
        </InputLabel>
      ) : null}
      <Input
        classes={{
          input: inputClasses,
          root: marginTop,
          disabled: classes.disabled
        }}
        onChange={this.changeInput}
        onPaste={this.changeInput}
        id={id}
        value={value}
        defaultValue={defaultUser ? defaultUser.NIN : null}
        inputProps={inputProps}
      />
      {foundUserBox}
    </FormControl>);
  }
}

UserSearch.propTypes = {
  classes: PropTypes.object.isRequired,
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  onFoundUser: PropTypes.func.isRequired,
  onUserNotFound: PropTypes.func,
  searchDelay: PropTypes.number,
  defaultUser: PropTypes.object,
  skipStatusCheck: PropTypes.bool
};

export default withStyles(userSearchStyle)(UserSearch);
